<template>
    <div class="main">
        <div class="list-turma">

            <c-panel>

                <el-form label-position="top" class="u-mb-30">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8" :md="8" v-if="($store.state.user.tipo > 3 && $store.state.user.tipo <= 8) || $store.state.user.tipo == 10">
                            <el-form-item key="instituicao">
                                <el-select @change="changeInstituicao" v-model="filtro.instituicao.id" filterable placeholder="Pesquisar Instituição">
                                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item key="categoria">
                                <el-select
                                    :disabled="avaDesabilitado || !filtro.instituicao.id || loadingCategorias"
                                    @change="changeCategoria"
                                    v-model="filtro.categoria_id"
                                    filterable
                                    placeholder="Selecionar Categoria">
                                    <el-option v-for="(item, i) in categorias" :key="i" :label="item.name" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item key="curso">
                                <el-select
                                    :disabled="avaDesabilitado || !filtro.categoria_id || loadingCursos"
                                    @change="changeCurso"
                                    v-model="filtro.course_id"
                                    filterable
                                    placeholder="Selecionar Curso">
                                    <el-option v-for="(item, i) in cursos" :key="i" :label="item.fullname" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="$store.state.user.tipo == 6" :xs="24" :sm="4" :md="4" class="u-text-right">
                            <el-button type="primary" @click="showDialogImportAlunos()">IMPORTAR ALUNOS</el-button>
                        </el-col>
                    </el-row>
                </el-form>

                <div class="container-table">
                    <table class="table table-striped" v-if="!avaDesabilitado">
                        <thead>
                            <tr>
                                <th class="hidden-mobile" style="width: 70px;">ID</th>
                                <th style="width: 70px;" class="u-text-center hidden-mobile">Foto</th>
                                <th>Nome</th>
                                <th class="hidden-mobile">Login</th>
                                <th class="hidden-mobile">Email</th>
                            </tr>
                        </thead>
                        <tbody v-if="statusList">
                            <tr v-for="item in items" :key="item.id">
                                <td class="hidden-mobile">{{ item.id }}</td>
                                <td class="u-text-center hidden-mobile">
                                    <img
                                        v-if="item.profileimageurlsmall"
                                        :src="item.profileimageurlsmall"
                                        style="width: 32px; height: 32px; border-radius: 50%;" />
                                    <span v-else>-</span>
                                </td>
                                <td>{{ item.fullname }}</td>
                                <td class="hidden-mobile">{{ item.username }}</td>
                                <td class="hidden-mobile">{{ item.email }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-if="avaDesabilitado" class="u-text-center u-mt-25">
                        <el-button @click="habilitarAva()" class="btn-habilitar-ava" type="success" round>HABILITAR</el-button>
                        <i style="display: block; margin-top: 20px;">O ambiente ava está desabilitado para esta instituição. Clique no botão acima para habilitar o Ambiente Virtual de Aprendizagem.</i>
                    </div>

                    <div v-if="!statusList" class="u-text-center u-mt-25">
                        <img src="/public/img/loading-bar.gif" />
                    </div>
                </div>

                <div v-if="!avaDesabilitado && statusList && filtro.instituicao.id && !filtro.categoria_id && items.length === 0">
                    <h4 class="u-text-center">selecione uma categoria</h4>
                </div>

                <div v-if="!avaDesabilitado && statusList && filtro.instituicao.id && filtro.categoria_id && !filtro.course_id && items.length === 0">
                    <h4 class="u-text-center">selecione um curso</h4>
                </div>

                <div v-if="!avaDesabilitado && statusList && filtro.course_id && items.length === 0">
                    <h4 class="u-text-center">nenhum aluno matriculado neste curso</h4>
                </div>

                <div v-if="!avaDesabilitado && statusList && !filtro.instituicao.id && items.length === 0">
                    <h4 class="u-text-center">selecione uma instituição</h4>
                </div>

            </c-panel>
        </div>

        <el-dialog :close-on-click-modal="false" title="IMPORTAR ALUNOS" width="70%" top="5vh" :visible.sync="dialogImportAlunos">
            <div class="main">
                <el-form @submit.native.prevent="onSubmitImportarAlunos" :model="formImportAlunos" ref="formImportAlunos" label-position="top">

                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-select v-model="formImportAlunos.turma_id" filterable placeholder="Turma">
                                <el-option-group
                                    v-for="(grupo, i) in turmas"
                                    :key="i"
                                    label="">
                                <el-option
                                    v-for="turma in grupo"
                                    :key="turma.id"
                                    :label="`${turma.curso.nome} ${turma.nome}`"
                                    :value="turma.id">
                                </el-option>
                                </el-option-group>
                            </el-select>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-form-item class="u-text-right u-mt-15">
                                <el-button type="primary" id="btn-modelo" native-type="submit">IMPORTAR</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data: () => ({
        avaDesabilitado: false,
        loadingTurmas: false,
        statusList: true,
        loadingCategorias: false,
        loadingCursos: false,
        filtro: {
            instituicao: {
                id: '',
                nome: ''
            },
            categoria_id: '',
            course_id: ''
        },
        categorias: [],
        cursos: [],
        items: [],
        turmas: [],
        dialogImportAlunos: false,
        formImportAlunos: {
            turma_id: '',
            course_id: ''
        }
    }),
    mounted(){
        if(this.$store.state.config.instituicao){
            this.filtro.instituicao = this.$store.state.config.instituicao;
        }

        this.loadCategorias();
    },
    methods: {
        async changeInstituicao(){
            if(this.$store.state.user.tipo > 3 && this.$store.state.user.tipo <= 8){
                await this.$store.dispatch('setInstituicao', this.filtro.instituicao.id);
            }

            this.filtro.categoria_id = '';
            this.filtro.course_id = '';
            this.cursos = [];
            this.items = [];
            this.loadCategorias();
        },

        changeCategoria(){
            this.filtro.course_id = '';
            this.items = [];
            this.loadCursos();
        },

        changeCurso(){
            this.loadingUsuarios();
        },

        loadCategorias(){
            if(!this.$store.state.config.instituicao || !this.$store.state.config.instituicao.id){
                this.categorias = [];
                this.cursos = [];
                this.items = [];
                return false;
            }

            let i = this.$store.state.config.instituicao.id;
            this.loadingCategorias = true;
            this.avaDesabilitado = false;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/ava/categorias?instituicao_id=${i}`, this.$store.getters.getHeaderAuth).then(response => {
                
                if(typeof response.data.ava_desabilitado !== 'undefined'){
                    this.avaDesabilitado = response.data.ava_desabilitado;
                }
                
                this.categorias = response.data || [];
                this.loadingCategorias = false;

                if(this.filtro.categoria_id){
                    this.loadCursos();
                }
            }).catch((error) => {
                this.loadingCategorias = false;
                this.$store.commit('throwException', error);
            });
        },

        loadCursos(){
            if(!this.filtro.categoria_id){
                this.cursos = [];
                return false;
            }

            this.loadingCursos = true;
            this.cursos = [];

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/ava/cursos?categoria_id=${this.filtro.categoria_id}`, this.$store.getters.getHeaderAuth).then(response => {
                this.cursos = (response.data && response.data.courses) ? response.data.courses : [];
                this.loadingCursos = false;
            }).catch((error) => { this.loadingCursos = false; this.$store.commit('throwException', error); });
        },

        loadingUsuarios(){
            if(!this.filtro.course_id){
                this.items = [];
                this.statusList = true;
                return false;
            }

            this.statusList = false;
            this.items = [];

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/ava/usuarios?course_id=${this.filtro.course_id}`, this.$store.getters.getHeaderAuth).then(response => {
                this.items = response.data || [];
                this.statusList = true;
            }).catch((error) => { this.statusList = true; this.$store.commit('throwException', error); });
        },

        loadTurmas(){

            this.turmas = [];
            this.filtro.turma_id = '';
            
            if(!this.filtro.instituicao || !this.filtro.instituicao.id) {
                return;
            }        
            
            this.loadingTurmas = true;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListDiario/${this.filtro.instituicao.id}/12`, this.$store.getters.getHeaderAuth).then(response => {

                this.turmas = response.data;      
                this.loadingTurmas = false;          

            }).catch((error) => { this.$store.commit('throwException', error); });

        },

        showDialogImportAlunos(){           
           
            this.loadTurmas();
            this.formImportAlunos.turma_id = '';
            this.dialogImportAlunos = true;
        },

        async onSubmitImportarAlunos(){

            window.eventBus.$emit('loading', true);

            this.formImportAlunos.course_id = this.filtro.course_id;  

            let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ava/importar-alunos`, this.formImportAlunos, this.$store.getters.getHeaderAuth);

            if(typeof response.data.erro !== 'undefined'){

                window.eventBus.$emit('loading', false);
                window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});

            }else{

                this.dialogAlterarData = false;
                window.eventBus.$emit('loading', false);
                this.dialogImportAlunos = false;
                this.loadingUsuarios();
                window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
            }                      
        },

        habilitarAva(){

            if(!this.filtro.instituicao || !this.filtro.instituicao.id) {

                window.eventBus.$emit('alert', {msg: 'Por favor, selecione uma instituição.', type: 'warning'});
                return false;
            }

            for(let i in this.$store.state.instituicoes) {
                if(this.$store.state.instituicoes[i].id == this.filtro.instituicao.id) {
                    this.filtro.instituicao.nome = this.$store.state.instituicoes[i].nome;
                    break;
                }
            }

            let payload = {
                instituicao_id: this.filtro.instituicao.id,
                cod: `I${this.filtro.instituicao.id}`,
                nome: this.filtro.instituicao.nome        
            };
            
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ava/categoria`, payload, this.$store.getters.getHeaderAuth).then(response => {
                
                window.eventBus.$emit('loading', false);
                window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                this.loadCategorias();

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },
    },
    components:{}
}
</script>
<style>
    .btn-habilitar-ava{ 
        font-size: 12px;
    }
</style>